import "./App.css";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MainPage from "./pages/MainPage";
import PersonalPage from "./pages/PersonalPage";
import Login from "./pages/LoginPage";
import RegPage from "./pages/RegPage";
import ResetPage from "./pages/ResetPage";
import Oferta from "./pages/Oferta";
import { Routes, Route, Link, Outlet, Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import MenuIcon from "@mui/icons-material/Menu";
import { userSlice } from "./redux/user/userSlice";
import PrivateRoute from "./components/PrivateRoute";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Tooltip } from "@mui/material";
import Confidencial from "./pages/Confidencial";
import EmployeeGuidePage from "./pages/EmployeeGuidePage";
import LandingPageNav from "./components/LandingPageNav";
import useMediaQuery from "./hooks/useMediaQuery";

const { exitHandle, resetSelectedProject } = userSlice;

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<RegPage />} />
        <Route path="/reset" element={<ResetPage />} />
        <Route path="/reset-password/*" element={<ResetPage />} />
        <Route path="/oferta" element={<Oferta />} />
        <Route path="/politic-confidencial" element={<Confidencial />} />
        <Route path="/dlya-sotrudnika" element={<EmployeeGuidePage />} />
        <Route
          path="/main/*"
          element={
            <PrivateRoute>
              <PersonalPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

function Layout() {
  const dispatch = useDispatch();
  const login = useSelector((state) => state.user?.data?.user?.login);
  const { pathname } = useLocation();
  const isLanding = pathname === "/";
  const isWorkspace = pathname.startsWith("/main");
  const isMobileNav = useMediaQuery("(max-width: 900px)");
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const telegramUsername = "/MoGame_Support";
  const telegramLink = `https://t.me/${telegramUsername}`;

  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [pathname]);

  const headerClassName = [
    "header",
    isLanding ? "header--landing" : "",
    isWorkspace ? "header--workspace" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="app-layout">
      <header className={headerClassName}>
        <div className="header__brand">
          {login && isWorkspace && isMobileNav ? (
            <IconButton
              className="header__menu-btn"
              aria-label="Открыть меню"
              onClick={() => setMobileSidebarOpen(true)}
              size="small"
            >
              <MenuIcon fontSize="small" />
            </IconButton>
          ) : null}
          <Link
            to={login ? "/main" : "/"}
            onClick={() => dispatch(resetSelectedProject())}
            style={{ textDecoration: "none" }}
          >
            <span className="header__logo">InChat</span>
          </Link>
        </div>

        {isLanding ? <LandingPageNav variant="header" /> : null}

        <div className="header__actions">
          {login ? (
            <div className="header__user-bar">
              <Tooltip title="Профиль" placement="bottom">
                <Link
                  to="/main/profile"
                  onClick={() => dispatch(resetSelectedProject())}
                  className="header__profile-link"
                  aria-label="Профиль"
                >
                  <PersonOutlineIcon sx={{ color: "white" }} />
                </Link>
              </Tooltip>
              <div className="header__login">
                <Link
                  to="/main/profile"
                  onClick={() => dispatch(resetSelectedProject())}
                  className="header__login-link"
                >
                  {login}
                </Link>
              </div>
              <Link
                to="/main/price"
                onClick={() => dispatch(resetSelectedProject())}
                className="header__tariffs-link"
              >
                Тарифы
              </Link>
              <Tooltip title="Написать в поддержку" placement="left">
                <div className="support">
                  <a
                    href={telegramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SupportAgentIcon sx={{ color: "white" }} />
                  </a>
                </div>
              </Tooltip>
              <LogoutIcon
                className="header__logout"
                sx={{ cursor: "pointer", color: "white" }}
                onClick={() => dispatch(exitHandle())}
              />
            </div>
          ) : (
            <div className="header__guest-bar">
              <Link to="/main/price" className="header__tariffs-link">
                Тарифы
              </Link>
              <Tooltip title="Написать в поддержку" placement="left">
                <div className="support">
                  <a
                    href={telegramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SupportAgentIcon sx={{ color: "white" }} />
                  </a>
                </div>
              </Tooltip>
              <Link to="/login">
                <Button
                  sx={{ bgcolor: "white" }}
                  variant="outlined"
                  size="small"
                >
                  Войти
                </Button>
              </Link>
            </div>
          )}
        </div>
      </header>

      <div className="app-layout__body">
        <Outlet
          context={{
            mobileSidebarOpen,
            setMobileSidebarOpen,
            closeMobileSidebar: () => setMobileSidebarOpen(false),
          }}
        />
      </div>
    </div>
  );
}

export default App;
